import { images } from "@/assets";
import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardTitle,
} from "@/components/ui";
import { formatAmount } from "@/lib/utils";
import { Banknote } from "lucide-react";
import { FormSectionHeader, Loader } from "@/components";
import useFinancialOversight from "./useFinancialOversight";

const FinancialOversight = () => {
  const {
    isExpenseIncomeDataLoading,
    expenseIncomeData,
    onOverdueClick,
    onDueClick,
    onIncomePerformanceClick,
  } = useFinancialOversight();
  return (
    <div className="bg-white rounded-lg p-[20px]">
      <FormSectionHeader className="text-[18px] font-[500]">
        Financial Oversight
      </FormSectionHeader>
      {isExpenseIncomeDataLoading ? (
        <Loader />
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px]">
          <Card className="bg-amber-100 border-none">
            <CardTitle className="flex flex-row items-center gap-4 px-5 text-[16px] md:text-[20px]">
              <div className="bg-white rounded-full h-[60px] w-[60px] p-2 flex items-center justify-center">
                <Banknote className="h-[30px] w-[30px]" />
              </div>
              Expense Performance
            </CardTitle>
            <CardContent className="grid grid-cols-1 gap-5">
              <div className="bg-[rgba(255,255,255,0.7)] mx-5 p-4 rounded-lg grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="grid grid-cols-1 text-[15px] mt-2 font-[500] col-span-2">
                  <div className="flex flex-col items-start lg:flex-row lg:items-center lg:gap-3">
                    <span>Overdue Invoices</span>
                    <Button
                      variant="link"
                      className="!p-0 !m-0"
                      onClick={onOverdueClick}
                    >
                      View Details
                    </Button>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-yellow-500 text-[26px]">
                    <span>
                      {expenseIncomeData?.data?.totalOverdueCount || 0}
                    </span>
                    <span>
                      {formatAmount(
                        expenseIncomeData?.data?.overdueAmount || 0
                      )}
                    </span>
                  </div>
                </div>
                <div className="flex items-end -mb-[17px] justify-end">
                  <img src={images.expense_performance} className="h-[100px]" />
                </div>
              </div>
              <div className="bg-[rgba(255,255,255,0.7)] mx-5 p-4 rounded-lg grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="grid grid-cols-1 text-[15px] mt-2 font-[500] col-span-2">
                  <div className="flex flex-col items-start lg:flex-row lg:items-center lg:gap-3">
                    <span>Invoices due in 7 days</span>
                    <Button
                      variant="link"
                      className="!p-0 !m-0"
                      onClick={onDueClick}
                    >
                      View Details
                    </Button>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-yellow-500 text-[26px]">
                    <span>{expenseIncomeData?.data?.totalDueCount || 0}</span>
                    <span>
                      {formatAmount(expenseIncomeData?.data?.dueAmount || 0)}
                    </span>
                  </div>
                </div>
                <div className="flex items-end -mb-[17px] justify-end">
                  <img src={images.expense_performance} className="h-[100px]" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card className="bg-blue-100 border-none">
            <CardTitle className="flex flex-row items-center gap-4 px-5 text-[16px] md:text-[20px]">
              <div className="bg-white rounded-full h-[60px] w-[60px] p-2 flex items-center justify-center">
                <Banknote className="h-[30px] w-[30px]" />
              </div>
              Income Performance
            </CardTitle>
            <CardContent className="bg-[rgba(255,255,255,0.7)] mx-5 p-4 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="flex flex-row gap-3">
                  <div className="bg-primary rounded-full p-2 flex items-center justify-center text-white h-[40px] w-[40px]">
                    <Banknote />
                  </div>
                  <div className="flex flex-col text-[16px] mt-2 font-[500]">
                    <div className="w-[260px] flex flex-col lg:flex-row lg:items-center lg:gap-1">
                      Properties{" "}
                      <span className="text-[11px] font-[400]">
                        {"30+ Days Outstanding Bills"}
                      </span>
                    </div>
                    <div className="text-primary text-[26px] flex flex-col">
                      <span>{expenseIncomeData?.data?.totalProperty || 0}</span>
                      <span>
                        {formatAmount(
                          expenseIncomeData?.data?.propertyAmount || 0
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-end -mb-[17px]">
                  <img src={images.income_performance} className="h-[100px]" />
                </div>
              </div>
            </CardContent>
            <CardFooter className="flex justify-end">
              <Button onClick={onIncomePerformanceClick}>View Details</Button>
            </CardFooter>
          </Card>
        </div>
      )}
    </div>
  );
};

export default FinancialOversight;
